[
  {
    "id": "2026-07-29",
    "date": "2026-07-29",
    "dayNumber": 1,
    "title": "Первое знакомство с Волгой",
    "summary": "Группа добралась до базы, устроилась и сразу вошла в ритм путешествия: купание, командные правила и первая лапта.",
    "paragraphs": [
      "После встречи на станции ребята приехали на базу на полуострове Копылово, познакомились с территорией и разместились. Солнечная погода позвала всех к воде: кто-то плавал, кто-то решился прыгнуть с понтона, а кто-то выбрал спокойный отдых у берега.",
      "После обеда участники обсудили правила, традиции и то, как заботиться друг о друге в большой группе. День продолжился лаптой, вечерним купанием и общим кругом, где каждый мог рассказать о своих ожиданиях и первых впечатлениях."
    ],
    "locations": [
      {
        "id": "zhigulevskoe-more",
        "name": "станция Жигулёвское Море",
        "coordinates": [
          49.5260862,
          53.4774098
        ],
        "accuracy": "verified"
      },
      {
        "id": "kopylovo",
        "name": "полуостров Копылово",
        "coordinates": [
          49.5689451,
          53.4551636
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-360",
      "photo-444",
      "photo-476"
    ]
  },
  {
    "id": "2026-07-30",
    "date": "2026-07-30",
    "dayNumber": 2,
    "title": "Пробный выход",
    "summary": "Короткий маршрут к песчаной косе помог проверить обувь, походный строй и место будущей стоянки.",
    "paragraphs": [
      "Утро началось с игровой зарядки, завтрака и подготовки к первому радиальному выходу — прогулке налегке с возвращением на базу. Колонна дошла до песчаной косы, где ребята привыкали к походному темпу и заранее посмотрели место первой стоянки.",
      "Во второй половине дня команды выполняли задания на сплочение и учились договариваться. После ужина прошли малые круги, а завершился день спокойным кинопросмотром."
    ],
    "locations": [
      {
        "id": "kopylovo",
        "name": "полуостров Копылово",
        "coordinates": [
          49.5689451,
          53.4551636
        ],
        "accuracy": "verified"
      },
      {
        "id": "sand-spit",
        "name": "песчаная коса",
        "coordinates": [
          49.603,
          53.451
        ],
        "accuracy": "approximate"
      }
    ],
    "media": [
      "photo-512",
      "photo-518",
      "photo-528"
    ]
  },
  {
    "id": "2026-07-31",
    "date": "2026-07-31",
    "dayNumber": 3,
    "title": "Готовимся к походу",
    "summary": "Рюкзаки, авторские футболки и первая настоящая тренировка на катамаранах.",
    "paragraphs": [
      "После зарядки по группам ребята разбирались, как собрать рюкзак, и вместе с наставниками проверяли вещи для водного и пешего маршрутов. Затем каждый оформил собственную походную футболку.",
      "Главным событием стали занятия на воде. В спасательных жилетах участники осваивали катамараны, синхронную греблю и движение связкой через фарватер. Вечером можно было отдохнуть в бане, поплавать или посмотреть фильм."
    ],
    "locations": [
      {
        "id": "kopylovo",
        "name": "полуостров Копылово",
        "coordinates": [
          49.5689451,
          53.4551636
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-668",
      "photo-713",
      "photo-717"
    ]
  },
  {
    "id": "2026-08-01",
    "date": "2026-08-01",
    "dayNumber": 4,
    "title": "Тактика и ориентирование",
    "summary": "Турнир по лапте, походные узлы, квест по карте и большая командная зарница.",
    "paragraphs": [
      "Команды сыграли друг с другом в лапту, а между матчами освоили несколько полезных узлов. После хозяйственных дел группа отправилась на квест по ориентированию: капитаны работали с условной картой, а участники искали отмеченные точки.",
      "В зарнице пригодились стратегия, скорость и умение распределять роли. Вечером все собрались у костра, пели под гитару, делились впечатлениями на общем круге, а самые бодрые закончили день ночными прятками."
    ],
    "locations": [
      {
        "id": "kopylovo",
        "name": "полуостров Копылово",
        "coordinates": [
          49.5689451,
          53.4551636
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-858",
      "photo-875",
      "photo-885"
    ]
  },
  {
    "id": "2026-08-02",
    "date": "2026-08-02",
    "dayNumber": 5,
    "title": "Последний день на базе",
    "summary": "Финальная тренировка на воде, сбор рюкзаков, установка палаток и распределение походных ролей.",
    "paragraphs": [
      "Утром четыре катамарана снова вышли на Волгу. Ребята повторили команды и управление, а затем вернулись к сборам: впереди начинался самостоятельный походный этап.",
      "После мастер-класса по палаткам команды тренировались быстро ставить лагерь. Вечером участники завершили сбор вещей, распределили зоны ответственности и провели итоговый круг у костра."
    ],
    "locations": [
      {
        "id": "kopylovo",
        "name": "полуостров Копылово",
        "coordinates": [
          49.5689451,
          53.4551636
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-932",
      "photo-934",
      "photo-941"
    ]
  },
  {
    "id": "2026-08-03",
    "date": "2026-08-03",
    "dayNumber": 6,
    "title": "Поход начинается",
    "summary": "Первый лагерь на песчаной косе, палатки, костёр и самостоятельно приготовленный обед.",
    "paragraphs": [
      "После раннего подъёма и последних сборов группа пешком дошла до стоянки, которую заметила во время пробного выхода. На месте каждый включился в свою роль: появились палатки, костровые подготовили огонь, а водонос обеспечил лагерь водой.",
      "Первый приготовленный на костре обед стал отдельным событием. После купания и обустройства лагеря к группе на катамаранах приехали гости, и большой гитарный круг завершил первый походный день."
    ],
    "locations": [
      {
        "id": "sand-spit",
        "name": "песчаная коса",
        "coordinates": [
          49.603,
          53.451
        ],
        "accuracy": "approximate"
      }
    ],
    "media": [
      "photo-1018",
      "photo-1039",
      "photo-1050"
    ]
  },
  {
    "id": "2026-08-04",
    "date": "2026-08-04",
    "dayNumber": 7,
    "title": "Первые километры по воде",
    "summary": "Катамараны пересекли Волгу, сделали остановку в Бахиловой Поляне и продолжили путь к островной стоянке.",
    "paragraphs": [
      "Утро на песчаной косе началось со сборки лагеря и походных блинчиков. Первую часть водного перехода катамараны шли связкой: наставники показывали технику гребли и помогали распределить усилия по бортам.",
      "На берегу Бахиловой Поляны группа пополнила воду и посетила музей Жигулёвского заповедника. Затем команды уже самостоятельно управляли загруженными катамаранами и к вечеру разбили новый лагерь на острове."
    ],
    "locations": [
      {
        "id": "bakhilova-polyana",
        "name": "Бахилова Поляна",
        "coordinates": [
          49.66989,
          53.43352
        ],
        "accuracy": "verified"
      },
      {
        "id": "island-camp",
        "name": "островная стоянка",
        "coordinates": [
          49.79,
          53.445
        ],
        "accuracy": "approximate"
      }
    ],
    "media": [
      "photo-1069",
      "photo-1079",
      "photo-1082"
    ]
  },
  {
    "id": "2026-08-05",
    "date": "2026-08-05",
    "dayNumber": 8,
    "title": "Остров Фестивальный",
    "summary": "Собранные команды уверенно прошли следующий водный переход и устроили лагерь на новом острове.",
    "paragraphs": [
      "К этому дню участники уже хорошо знали свои обязанности: завтрак приготовили на дровах, лагерь собрали общими силами, а на воде каждый занял привычное место в экипаже.",
      "Катамараны дошли до острова Фестивального. После установки палаток и бытовых дел ребята успели искупаться и постираться, а арбуз после жаркого перехода стал приятным сюрпризом."
    ],
    "locations": [
      {
        "id": "festivalny-island",
        "name": "остров Фестивальный",
        "coordinates": [
          49.9154475,
          53.4651918
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-1165",
      "photo-1170",
      "photo-1195"
    ]
  },
  {
    "id": "2026-08-06",
    "date": "2026-08-06",
    "dayNumber": 9,
    "title": "Двенадцать километров по Волге",
    "summary": "Самый длинный водный переход завершил сплав и вывел группу к началу пешего маршрута.",
    "paragraphs": [
      "От острова Фестивального четыре катамарана прошли около двенадцати километров. Экипажи выбирали свой ритм, объединяли суда бортами, сменяли гребцов и по дороге любовались волжскими берегами.",
      "Водный этап закончился у острова Голодного. Катамараны связали и пересекли фарватер, затем оборудование отправилось на базу, а группа пешком добралась до стоянки на правом берегу."
    ],
    "locations": [
      {
        "id": "golodny-island",
        "name": "остров Голодный",
        "coordinates": [
          50.1056488,
          53.4108474
        ],
        "accuracy": "verified"
      },
      {
        "id": "right-bank-camp",
        "name": "стоянка на правом берегу",
        "coordinates": [
          50.046,
          53.405
        ],
        "accuracy": "approximate"
      }
    ],
    "media": [
      "photo-1297",
      "photo-1298",
      "photo-1303"
    ]
  },
  {
    "id": "2026-08-07",
    "date": "2026-08-07",
    "dayNumber": 10,
    "title": "Каменная Чаша",
    "summary": "После сплава — первая дневка и радиальный выход к одному из самых известных мест Самарской Луки.",
    "paragraphs": [
      "Дневка дала возможность не переносить лагерь, но день всё равно получился походным. Группа отправилась к Каменной Чаше неподалёку от Ширяева, делая остановки у источников, гамаков и качелей.",
      "На обратном пути ребята заглянули в местную пекарню, а затем вернулись в лагерь, приготовили ужин и восстановили силы после длинной прогулки."
    ],
    "locations": [
      {
        "id": "stone-bowl",
        "name": "Каменная Чаша",
        "coordinates": [
          49.922376,
          53.409508
        ],
        "accuracy": "verified"
      },
      {
        "id": "right-bank-camp",
        "name": "стоянка на правом берегу",
        "coordinates": [
          50.046,
          53.405
        ],
        "accuracy": "approximate"
      }
    ],
    "media": [
      "photo-1264",
      "photo-1267",
      "photo-1273"
    ]
  },
  {
    "id": "2026-08-08",
    "date": "2026-08-08",
    "dayNumber": 11,
    "title": "День в Ширяеве",
    "summary": "Вторая дневка прошла между лагерными делами, большим кругом и музеем на волжском берегу.",
    "paragraphs": [
      "Утро посвятили стирке, укреплению лагеря и подготовке к выходу. На общем круге ребята обсуждали завершившийся сплав и отмечали, как заметно команда стала организованнее.",
      "В Ширяеве группа посетила дом-музей Репина и узнала историю создания картины «Бурлаки на Волге». После экскурсии участники ещё раз заглянули в знакомую пекарню и вернулись на ранний отбой."
    ],
    "locations": [
      {
        "id": "shiryayevo",
        "name": "Ширяево",
        "coordinates": [
          50.019196,
          53.416447
        ],
        "accuracy": "verified"
      },
      {
        "id": "right-bank-camp",
        "name": "стоянка на правом берегу",
        "coordinates": [
          50.046,
          53.405
        ],
        "accuracy": "approximate"
      }
    ],
    "media": [
      "photo-1287",
      "photo-1295",
      "photo-1463"
    ]
  },
  {
    "id": "2026-08-09",
    "date": "2026-08-09",
    "dayNumber": 12,
    "title": "Дождь у Гавриловой Поляны",
    "summary": "Пеший переход привёл группу к новой стоянке, где команду встретил сильный дождь.",
    "paragraphs": [
      "Рано утром участники распределили общее снаряжение и вышли на маршрут. По пути они поднялись на смотровую площадку, откуда был виден один из постоянных паромных маршрутов через Волгу.",
      "Лагерь разбили неподалёку от Гавриловой Поляны. Начавшийся дождь стал проверкой слаженности: ребята быстро поставили палатки, натянули тенты и сохранили вещи сухими, а после непогоды приготовили ужин и обсудили день на круге."
    ],
    "locations": [
      {
        "id": "gavrilova-polyana",
        "name": "Гаврилова Поляна",
        "coordinates": [
          50.1223099,
          53.3654126
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-1480",
      "photo-1482",
      "photo-1491"
    ]
  },
  {
    "id": "2026-08-10",
    "date": "2026-08-10",
    "dayNumber": 13,
    "title": "День самоорганизации",
    "summary": "Наставники наблюдали со стороны, пока участники самостоятельно поддерживали весь походный быт.",
    "paragraphs": [
      "Свободный подъём не отменил общих задач. Ребята распределяли воду и дрова, готовили еду, сушили вещи после дождя и следили за лагерем — уже без привычных напоминаний.",
      "День показал, чему команда научилась за время похода: замечать необходимую работу, договариваться и доводить дело до результата. Вечером к супу добавилась запечённая на костре картошка, а впереди ждал самый длинный пеший переход."
    ],
    "locations": [
      {
        "id": "stone-lake",
        "name": "Каменное озеро",
        "coordinates": [
          50.1243026,
          53.3359793
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-1498",
      "photo-1504",
      "photo-1506"
    ]
  },
  {
    "id": "2026-08-11",
    "date": "2026-08-11",
    "dayNumber": 14,
    "title": "Финальный пеший переход",
    "summary": "Около двенадцати километров от Каменного озера до Рождествена завершили походную часть программы.",
    "paragraphs": [
      "Группа прошла самый длинный пеший участок — примерно двенадцать километров. В дороге ребята помогали друг другу с вещами, поддерживали тех, кому было труднее, и поэтому добрались до новой стоянки уверенно и дружно.",
      "После установки лагеря участники собрали дрова и искупались на песчаном пляже. Вечерний круг был посвящён итогам похода: для многих это оказался первый опыт такой большой самостоятельной дороги."
    ],
    "locations": [
      {
        "id": "stone-lake",
        "name": "Каменное озеро",
        "coordinates": [
          50.1243026,
          53.3359793
        ],
        "accuracy": "verified"
      },
      {
        "id": "rozhdestveno",
        "name": "Рождествено",
        "coordinates": [
          50.0603068,
          53.2303602
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-1512",
      "photo-1523",
      "photo-1525"
    ]
  },
  {
    "id": "2026-08-12",
    "date": "2026-08-12",
    "dayNumber": 15,
    "title": "Через Волгу — в Самару",
    "summary": "Последние часы с рюкзаками, паромная переправа и первый городской вечер после похода.",
    "paragraphs": [
      "После финальной сборки лагеря группа несколько часов шла по сельской местности к переправе в Рождествене. На пароме ребята прощались с походным берегом и смотрели на Волгу уже с середины реки.",
      "В Самаре участники разместились, привели себя в порядок и вышли на короткую прогулку по скверам, набережной и городскому пляжу. Вечером снова были сборы — на следующий день путешествие продолжалось в Казани."
    ],
    "locations": [
      {
        "id": "rozhdestveno",
        "name": "Рождествено",
        "coordinates": [
          50.0603068,
          53.2303602
        ],
        "accuracy": "verified"
      },
      {
        "id": "samara",
        "name": "Самара",
        "coordinates": [
          50.1014927,
          53.1956255
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-1577",
      "photo-1558",
      "photo-1562"
    ]
  },
  {
    "id": "2026-08-13",
    "date": "2026-08-13",
    "dayNumber": 16,
    "title": "Из Самары в Казань",
    "summary": "Утренняя экскурсия по Самаре и длинная дорога к третьему этапу путешествия.",
    "paragraphs": [
      "Утром ребята побывали на экскурсии по Самаре и узнали историю главных городских мест. После обеда группа погрузила вещи в автобус и отправилась дальше.",
      "За окнами сменялись пейзажи средней полосы, показалась Кама и всё чаще встречались названия на татарском языке. В Казань путешественники прибыли вечером, разместились и стали готовиться к первому полноценному городскому дню."
    ],
    "locations": [
      {
        "id": "samara",
        "name": "Самара",
        "coordinates": [
          50.1014927,
          53.1956255
        ],
        "accuracy": "verified"
      },
      {
        "id": "kazan",
        "name": "Казань",
        "coordinates": [
          49.1115022,
          55.7946485
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-1592",
      "photo-1624",
      "photo-1643"
    ]
  },
  {
    "id": "2026-08-14",
    "date": "2026-08-14",
    "dayNumber": 17,
    "title": "Казанский Кремль",
    "summary": "Экскурсия, улица Баумана и большой городской квест на внимательность и общение.",
    "paragraphs": [
      "После завтрака группа отправилась в Казанский Кремль. Ребята знакомились с историей города, увидели мечеть Кул-Шариф и успели выбрать сувениры, а затем вернулись привести в порядок походные вещи.",
      "Во второй половине дня команды получили пятьдесят заданий — от вопросов по экскурсии до поиска неизвестных памятников. Чтобы справиться, нужно было помнить детали, общаться с прохожими и быстро договариваться внутри команды."
    ],
    "locations": [
      {
        "id": "kazan",
        "name": "Казань",
        "coordinates": [
          49.1115022,
          55.7946485
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-1662",
      "photo-1672",
      "photo-1743"
    ]
  },
  {
    "id": "2026-08-15",
    "date": "2026-08-15",
    "dayNumber": 18,
    "title": "Квесты большого города",
    "summary": "Одни искали музыканта для общего вечера, другие — эксперта по культуре Казани, а параллельно учились обмениваться и договариваться.",
    "paragraphs": [
      "Новые команды получили непростые задачи. Первой предстояло найти гитариста, согласовать программу и организовать выступление для всей группы. Вторая искала местного специалиста, готового рассказать о своей профессии и связи с городом.",
      "Дополнительный квест строился на обмене небольших предметов с прохожими. Погода меняла планы, поиск занимал больше времени, чем ожидалось, но к вечеру главные договорённости состоялись."
    ],
    "locations": [
      {
        "id": "kazan",
        "name": "Казань",
        "coordinates": [
          49.1115022,
          55.7946485
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-1896",
      "photo-1899",
      "photo-1901"
    ]
  },
  {
    "id": "2026-08-16",
    "date": "2026-08-16",
    "dayNumber": 19,
    "title": "Последний день в Казани",
    "summary": "Встреча с приглашённым спортсменом, модный квест и долгожданный гитарный вечер.",
    "paragraphs": [
      "Участники встретились с местным спортсменом и расспросили его о тренировках, выборе профессии и сложностях большого спорта. После разговора команды отправились в секонд-хенды: нужно было подобрать наставникам подходящие к погоде образы в пределах заданного бюджета.",
      "Вечером состоялся гитарный концерт, который ребята организовали накануне. После музыки и показа собранных образов группа разобрала результаты квестов, поужинала и начала собирать вещи в дорогу домой."
    ],
    "locations": [
      {
        "id": "kazan",
        "name": "Казань",
        "coordinates": [
          49.1115022,
          55.7946485
        ],
        "accuracy": "verified"
      }
    ],
    "media": [
      "photo-2002",
      "photo-2046",
      "photo-2059"
    ]
  },
  {
    "id": "2026-08-17",
    "date": "2026-08-17",
    "dayNumber": 20,
    "title": "Дорога домой",
    "summary": "Финальные встречи, последние сборы и отъезд из Казани после двадцати дней большого пути.",
    "paragraphs": [
      "Утро осталось для последних общих дел и тёплого прощания. За три недели участники прошли базовую подготовку, водный и пеший маршруты, научились поддерживать походный быт и решать задачи в незнакомом городе.",
      "Путешествие завершилось на вокзале в Казани. Впереди была ночная дорога домой — уже с новыми друзьями, собственным походным опытом и длинной историей о Волге."
    ],
    "locations": [
      {
        "id": "kazan",
        "name": "Казань",
        "coordinates": [
          49.1115022,
          55.7946485
        ],
        "accuracy": "verified"
      }
    ],
    "media": []
  }
]
